import { createSlice } from "@reduxjs/toolkit";

export const mockAuthenticatedOrgDevices = [
  {
    "code": 1,
    "macAddress": "3c:33:32:14:ab:00",
    "message": "Failure"
  },
  {
    "code": 1,
    "macAddress": "bc:22:28:d7:64:80",
    "message": "Failure"
  },
  {
    "code": 1,
    "macAddress": "00:25:35:89:22:01",
    "message": "Failure"
  },
  {
    "code": 1,
    "macAddress": "3c:33:32:14:a2:00",
    "message": "Failure"
  },
  {
    "code": 0,
    "macAddress": "bc:22:28:72:0f:70",
    "message": "Success"
  }
];

export const authenticatedOrgSlice = createSlice({
  name: "onPremAuthenticatedOrgDevices",
  initialState: {
    resource: "authenticate",
    data: [...mockAuthenticatedOrgDevices],
  },
});

export default authenticatedOrgSlice.reducer;